import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-unsupported-browser',
  templateUrl: './unsupported-browser.component.html',
  styleUrls: ['./unsupported-browser.component.scss'],
  standalone: false,
})
export class UnsupportedBrowserComponent {
  constructor() {}
}
